module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"add field":"Feld hinzufügen","download data":"Daten herunterladen","new field":"Neues Feld","send":"Absenden","field input":"Eingabe","field checkbox":"Checkbox","field text":"Text","field submit":"Absenden","input text":"Text"}}')
  delete Component.options._Ctor
}
